<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                         _/
_/      子画面定義：処理中画面(STDSDC01C21)                                                                                  _/
_/                                                                                                                         _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
<template>
  <BaseModal :show="isShow">
    <div class="popup" style="width: 654px; max-height: 90vh">
      <div class="popup-head">処理中</div>
      <div class="popup-body blue">
        <div class="process-status">
          <span>処理進捗</span>
          <div class="process-status-wrap">
            <div class="progress">
              <div class="progress-bar" :style="{ width: percentage }"></div>
            </div>
            <span class="progress-size">
              {{ dataSpace }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  watch,
  ref,
  computed,
  onUnmounted,
} from "vue";
import BaseModal from "@/components/Base/BaseModal.vue";
import { API_DisplayFileProcessingScreen } from "@/api/Modules/DC01/STDSDC01C21.js";
import { PROGRESS_STATUS } from "@/util/enum.js";

const props = defineProps({
  // 親画面ID
  pageId: {
    type: String,
    required: true,
  },
  isShow: {
    type: Boolean,
    default: false,
  },
  total: {
    type: String || Number,
    default: 0,
  },
});

const processCount = ref(1); // 処理済件数
const processTotal = ref(0); // 全件数
const progressStatus = ref(PROGRESS_STATUS.NONE); // 進捗状態
const progressErrorCode = ref(""); // エラーコード
const progressErrorPosition = ref(0); // エラー位置
const progressErrorParaListString = ref(""); // エラーコードのパラメータ

const emit = defineEmits([
  "update:isShow",
  "processingOver",
  "processingError",
  "exception",
]);

// 画面表示フラグ
const isShow = computed({
  get() {
    return props.isShow;
  },
  set(value) {
    emit("update:isShow", value);
  },
});

// 進捗状況
const percentage = computed(() => {
  return processTotal.value == 0
    ? "0%"
    : toPercent(processCount.value / processTotal.value);
});

// 進捗情報表示
const dataSpace = computed(() => {
  const progressStatusValue =
    processCount.value >= 0 && processTotal.value == 0
      ? props.total != 0
        ? `処理中（1／${props.total.toLocaleString()}件）`
        : "処理中"
      : "処理中（" +
        processCount.value.toLocaleString() +
        "／" +
        processTotal.value.toLocaleString() +
        "件）";
  return progressStatusValue;
});

watch(
  () => isShow.value,
  (val) => {
    if (val) {
      sendToAPI();
      updateStatus();
    } else {
      clearTimer();
      processCount.value = 1;
      processTotal.value = 0;
    }
  }
);
watch(
  () => progressStatus.value,
  (val) => {
    if (val != PROGRESS_STATUS.IN_PROGRESS) {
      isShow.value = false;
      clearTimer();
      if (val == PROGRESS_STATUS.COMPLETED) {
        // 処理完了　親画面に通知
        emit("processingOver");
      } else if (val == PROGRESS_STATUS.ERROR) {
        // エラー　親画面に通知
        if (props.pageId == "STDSDC03C13" || props.pageId == "STDSDR02C07") {
          emit(
            "processingError",
            progressErrorPosition,
            progressErrorCode,
            progressErrorParaListString
          );
        } else {
          emit("processingError");
        }
      } else if (val == PROGRESS_STATUS.EXCEPTION) {
        // 例外（エラー）　親画面に通知
        emit("exception");
      }
      // 初期化
      progressStatus.value = PROGRESS_STATUS.NONE;
    }
  }
);

// 実行タイマー
var updateTimer = null;

// 処理進捗情報更新
const updateStatus = () => {
  updateTimer = setInterval(() => {
    sendToAPI();
  }, 5000);
};

//APIを実行する
const sendToAPI = () => {
  // パラメータ準備
  const prams = { pageId: props.pageId };
  API_DisplayFileProcessingScreen(prams).then((response) => {
    if (response.result == "0000") {
      processCount.value = response.processCount;
      processTotal.value = response.processTotal;
      progressStatus.value = response.progressStatus;
      progressErrorCode.value = response.errorCode;
      progressErrorPosition.value = response.ErrorPosition;
      progressErrorParaListString.value = response.errorParameterList;
    }
  });
};

// タイマーをクリアする
const clearTimer = () => {
  clearInterval(updateTimer);
};

const toPercent = (num) => {
  var str = Number(num * 100).toFixed(1);
  str += "%";
  return str;
};

onUnmounted(() => {
  clearTimer();
});
</script>
<style scoped></style>
